<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<div slot="header">Create New Project</div>
						<b-form @submit.prevent="checkFormValidity()" method="post">
							<b-form-group
								label="Code"
								label-for="code"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.code" name="code" id="code" type="text" placeholder="Code" :state="$v.form.code.$dirty ? !$v.form.code.$error : null" aria-describedby="code-live-feedback"></b-form-input>
								<b-form-invalid-feedback id="code-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Name"
								label-for="name"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.name" name="name" id="name" type="text" placeholder="Name" :state="$v.form.name.$dirty ? !$v.form.name.$error : null" aria-describedby="name-live-feedback"></b-form-input>
								<b-form-invalid-feedback id="name-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Phone"
								label-for="phone"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.phone" name="phone" id="phone" type="text" placeholder="Phone" :state="$v.form.phone.$dirty ? !$v.form.phone.$error : null" aria-describedby="phone-live-feedback"></b-form-input>
								<b-form-invalid-feedback id="phone-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Email"
								label-for="email"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.email" name="email" id="email" type="text" placeholder="Email" :state="$v.form.email.$dirty ? !$v.form.email.$error : null" aria-describedby="email-live-feedback"></b-form-input>
								<b-form-invalid-feedback id="email-live-feedback">This is a required field and must be a valid email.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Organization"
								label-for="organization"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.organization" name="organization" id="organization" type="text" placeholder="Organization" :state="$v.form.organization.$dirty ? !$v.form.organization.$error : null" aria-describedby="organization-live-feedback"></b-form-input>
								<b-form-invalid-feedback id="organization-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Address"
								label-for="address"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-textarea v-model="form.address" name="address" id="address" placeholder="Address" rows="4" max-rows="6" :state="$v.form.address.$dirty ? !$v.form.address.$error : null" aria-describedby="address-live-feedback"></b-form-textarea>
								<b-form-invalid-feedback id="address-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Operational Timezone"
								label-for="timezone"
								label-class="required"
								:label-cols="3"
								:horizontal="true"
								invalid-feedback="Please select one."
								:state="$v.form.timezone.$dirty ? !$v.form.timezone.$error : null">
								<model-select id="timezone" :options="timezoneDropDownList" v-model="form.timezone" :isError="$v.form.timezone.$dirty ? $v.form.timezone.$error : false" placeholder="Select Timezone"></model-select>
							</b-form-group>
							<b-form-group
								label="Select Device Type"
								label-for="deviceType"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-select v-model="form.deviceType"
															 name="deviceType"
															 id="deviceType"
															 :plain="true"
															 :options="deviceTypeDropDownList"
															 value="Please Select"
															 :state="$v.form.deviceType.$dirty ? !$v.form.deviceType.$error : null"
															 aria-describedby="device-type-live-feedback">
								</b-form-select>
								<b-form-invalid-feedback id="device-type-live-feedback">Please select one.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Reseller"
								label-for="resellerId"
								label-class="required"
								:label-cols="3"
								:horizontal="true"
								invalid-feedback="Please select one."
								:state="$v.form.resellerId.$dirty ? !$v.form.resellerId.$error : null">
<!--								<b-form-select v-model="form.resellerId"-->
<!--															 name="resellerId"-->
<!--															 id="reseller-id"-->
<!--															 :plain="true"-->
<!--															 :options="resellerDropDownList"-->
<!--															 value="Please Select"-->
<!--															 :state="$v.form.resellerId.$dirty ? !$v.form.resellerId.$error : null"-->
<!--															 aria-describedby="reseller-live-feedback">-->
<!--								</b-form-select>-->
<!--								<b-form-invalid-feedback id="reseller-live-feedback">Please select one.</b-form-invalid-feedback>-->
								<model-select
									id="reseller-id"
									:options="resellerDropDownList"
									v-model="form.resellerId"
									:isError="$v.form.resellerId.$dirty ? $v.form.resellerId.$error : false"
									placeholder="Select Reseller Name">
								</model-select>
							</b-form-group>
							<b-form-group
								label="Username"
								label-for="username"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.username" name="username" id="username" type="text" placeholder="Username" :state="$v.form.username.$dirty ? !$v.form.username.$error : null" aria-describedby="username-live-feedback" autocomplete="off"></b-form-input>
								<b-form-invalid-feedback id="username-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Password"
								label-for="password"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.password" name="password" id="password" type="password" placeholder="Password" :state="$v.form.password.$dirty ? !$v.form.password.$error : null" aria-describedby="password-live-feedback" autocomplete="new-password"></b-form-input>
								<b-form-invalid-feedback id="password-live-feedback">This is a required field and must be at least 6 characters long.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								label="Confirm Password"
								label-for="confirmPassword"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.confirmPassword" name="confirmPassword" id="confirmPassword" type="password" placeholder="Confirm Password" :state="$v.form.confirmPassword.$dirty ? !$v.form.confirmPassword.$error : null" aria-describedby="confirm-password-live-feedback" autocomplete="new-password"></b-form-input>
								<b-form-invalid-feedback id="confirm-password-live-feedback">This is a required field and must match the password.</b-form-invalid-feedback>
							</b-form-group>
							<div class="form-actions">
								<b-button type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Add New Project</b-button>
								&nbsp;
								<b-button type="button" variant="danger" @click="resetForm()"><i class="fa fa-ban"></i> Reset</b-button>
							</div>
						</b-form>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import { required, numeric, minValue, requiredIf, email, minLength, sameAs } from 'vuelidate/lib/validators';
import resellerService from "@/services/resellerService";
import toastService from "@/services/toastService";
import {ModelSelect} from "vue-search-select";
import customerService from "@/services/customerService";
import { TIMEZONE_LIST, DEFAULT_TIMEZONE } from '@/shared/timezoneConstants';

export default {
	name : "CreateProject",
	components : {
		ModelSelect
	},
	data : function () {
		return {
			form : {
				code : null,
				name : null,
				phone : null,
				email : null,
				organization : null,
				address : null,
				deviceType : null,
				username : null,
				password : null,
				confirmPassword : null,
				resellerId : null,
				timezone : DEFAULT_TIMEZONE
			},
			timezoneDropDownList: TIMEZONE_LIST,
			deviceTypeDropDownList: [
				{text: 'Please Select', value: null},
				{text: '1', value: 1},
				{text: '2', value: 2},
				{text: '3', value: 3}
			],
			resellerList : [],
			resellerDropDownList : [],
			loading : false
		}
	},
	validations : {
		form : {
			code : {
				required
			},
			name : {
				required
			},
			phone : {
				required
			},
			email : {
				required,
				validEmail: email
			},
			address : {
				required
			},
			deviceType : {
				required,
				minValue: minValue(1)
			},
			organization : {
				required
			},
			username : {
				required
			},
			password : {
				required,
				minLength: minLength(6)
			},
			confirmPassword : {
				required,
				sameAsPassword: sameAs('password')
			},
			resellerId: {
				required
			},
			timezone: {
				required
			}
		}
	},
	methods : {
		checkFormValidity : function () {
			let formHasErrors = false;

			this.$v.form.$touch();
			if (this.$v.form.$anyError) {
				formHasErrors = true;
			}

			if(formHasErrors) return;
			else this.createNewProject();
		},
		createNewProject : function () {
			const formData = {
				code: this.form.code,
				name: this.form.name,
				phone: this.form.phone,
				email: this.form.email,
				organization: this.form.organization,
				address: this.form.address,
				device_type: this.form.deviceType,
				username: this.form.username,
				password: this.form.password,
				reseller_id: this.form.resellerId,
				has_client_panel: false,
				has_school_panel: false,
				timezone: this.form.timezone
			};

			customerService.createNewProject(formData, (data) => {
				this.$nextTick(() => { this.$v.$reset() });
				this.resetForm();
				toastService.showSuccessToast("Project Successfully created");
			}, (error) => {
				toastService.showErrorToast("Could not create new project " + error);
			});
		},
		resetForm : function () {
			this.form.code = null;
			this.form.name = null;
			this.form.phone = null;
			this.form.email = null;
			this.form.organization = null;
			this.form.address = null;
			this.form.deviceType = null;
			this.form.username = null;
			this.form.password = null;
			this.form.confirmPassword = null;
			this.form.resellerId = null;
			this.form.timezone = DEFAULT_TIMEZONE;
		},
		getResellerList : function () {
			this.loading = true;
			resellerService.getResellerList((data) => {
				this.resellerList = data;
				this.createResellerDropDownList();
				this.loading = false;
			}, (error) => {
				this.loading = false;
				toastService.showErrorToast("Could not fetch reseller list " + error);
			});
		},
		createResellerDropDownList: function () {
			this.resellerList.forEach((item) =>{
				let reseller = new Object();
				reseller.text = item.name;
				reseller.value = item.id;
				this.resellerDropDownList.push(reseller);
			});
		}
	},
	created() {
		this.getResellerList();
	}
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
